export default [
  {
    path: '/users/staff',
    name: 'staff-list',
    component: () => import('@/views/users/staff/Index.vue'),
    meta: {
      pageTitle: 'Gestion du personnel',
      pageDesc: 'Liste complète des membres du personnel logistique. Utilisez les filtres et la recherche pour trouver un membre spécifique.',
      breadcrumb: [
        {
          text: 'Personnel',
          active: true,
          ariaLabel: 'Fil d’Ariane : liste du personnel',
        },
      ],
      breadcrumbLabel: 'Liste du personnel',
      requireLogin: true,
      roles: ['admin', 'superadmin'],
      admin: true,
    },
  },
  {
    path: '/users/staff/add',
    name: 'staff-add',
    component: () => import('@/views/users/staff/Create.vue'),
    meta: {
      pageTitle: 'Ajouter un membre du personnel',
      pageDesc: 'Ajoutez un nouveau membre du personnel logistique. Tous les champs marqués d’un astérisque sont obligatoires.',
      breadcrumb: [
        {
          text: 'Personnel',
          to: { name: 'staff-list' },
          ariaLabel: 'Retour à la liste du personnel',
        },
        {
          text: 'Ajouter',
          active: true,
          ariaLabel: 'Ajouter un membre du personnel',
        },
      ],
      breadcrumbLabel: 'Ajouter membre du personnel',
      requireLogin: true,
      roles: ['admin', 'superadmin'],
      admin: true,
    },
  },
  {
    path: '/users/staff/edit/:id',
    name: 'staff-edit',
    component: () => import('@/views/users/staff/Edit.vue'),
    meta: {
      pageTitle: 'Modifier un membre du personnel',
      pageDesc: 'Modifiez les informations d’un membre du personnel logistique. Vérifiez l’exactitude des données avant de valider.',
      breadcrumb: [
        {
          text: 'Personnel',
          to: { name: 'staff-list' },
          ariaLabel: 'Retour à la liste du personnel',
        },
        {
          text: 'Modifier',
          active: true,
          ariaLabel: 'Modifier un membre du personnel',
        },
      ],
      breadcrumbLabel: 'Modifier membre du personnel',
      requireLogin: true,
      roles: ['admin', 'superadmin'],
      admin: true,
    },
  },
  {
    path: '/users/staff/show/:id',
    name: 'staff-show',
    component: () => import('@/views/users/staff/Show.vue'),
    meta: {
      pageTitle: 'Détails du membre du personnel',
      pageDesc: 'Consultez les informations détaillées d’un membre du personnel logistique.',
      breadcrumb: [
        {
          text: 'Personnel',
          to: { name: 'staff-list' },
          ariaLabel: 'Retour à la liste du personnel',
        },
        {
          text: 'Détails',
          active: true,
          ariaLabel: 'Détails du membre du personnel',
        },
      ],
      breadcrumbLabel: 'Détails membre du personnel',
      requireLogin: true,
      roles: ['admin', 'superadmin'],
      admin: true,
    },
  },
]
